import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToHash: React.FC = () => {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const elementId = hash.replace('#', '');
            const element = document.getElementById(elementId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [hash]);

    return null;
};

export default ScrollToHash;
